import { useRef } from "react";
import PlatformLabels from "../platform-labels/PlatformLabels";
import Styles from "./AppMainScreen.module.scss";
import classnames from "classnames"
import { ReactComponent as LeftIcon } from "../../../icons/extra_icons/left.svg";
import PlaceholderIcon from "../../../icons/common/no_image_placeholder.webp";

interface AppMainScreenType {
  title: string;
  icon: string;
  description: string;
  screenshots: string[];
  visitLink?: string;
  type: number;
}

const AppMainScreen = ({
  title,
  icon,
  description,
  screenshots,
  visitLink,
  type
}: AppMainScreenType) => {


  const divRef = useRef<HTMLDivElement>(null);

  const handleScroll = (scrollOffset: any) => {
    if (divRef.current != null) {
      divRef.current.scrollTo({
        left: divRef.current.scrollLeft + scrollOffset,
        behavior: "smooth"
      });
    }
  };


  return (
    <div className={Styles.container}>
      <div className={Styles.app_header}>
        <div className={Styles.logo}>
          <img src={icon} />
        </div>
        <div className={Styles.title}>
          {title}
        </div>
      </div>
      <div className={Styles.description_block}>
        <div className={Styles.description}>
          {description}
          <div className={Styles.fader}></div>
        </div>
        <div className={Styles.type_block}>
          <PlatformLabels type={type} />
        </div>
      </div>
      <div className={Styles.images_container}>

        <div className={classnames(Styles.screenshots, type === 0 ? Styles.horizontal_scroll : Styles.vertical_scroll)} ref={divRef} style={{ overflowX: "scroll", scrollBehavior: "smooth" }}>
          {type === 0 && <div className={classnames(Styles.button_container, Styles.left)} onClick={() => handleScroll("-25")}>
            <LeftIcon />
          </div>}
          {
            screenshots.length ? (
              screenshots.map((imageLink: string, index: number) => {
                return (
                  <img className={type === 0 ? Styles.potrait : Styles.landscape} src={imageLink} key={index} />
                )
              })
            ) : (
                <img className={type === 0 ? Styles.potrait : Styles.landscape} src={PlaceholderIcon} />
            )
          }
          {type === 0 && <div className={classnames(Styles.button_container, Styles.right)} onClick={() => handleScroll("25")}>
            <LeftIcon />
          </div>}
        </div>


      </div>
    </div>
  )
}

export default AppMainScreen
